var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pointer-text",on:{"click":function($event){return _vm.handle()}}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }